import { Heading, Link, Tooltip } from "@/storybook-components";
import Item from "@/theme/components/item";
import { useAppSelector } from "@/redux/store/hooks";
import type { Project } from "@/types";

const ProjectName = ({ project }: { project: Project }): JSX.Element => {
  const { queryFilter } = useAppSelector((state) => state.projectFinder);
  const { baseUrl, siteUrl, projectLinkTarget, showProjectNameTooltip } =
    queryFilter;
  const { permalink, name } = project;

  const renderWithTooltip = () => {
    return (
      <Tooltip
        hasArrow
        placement="top"
        borderRadius="md"
        label={name}
        aria-label={name}
        fontFamily="inherit"
      >
        {name}
      </Tooltip>
    );
  };

  return (
    <Item className="ehq-cardItem">
      <Heading
        as="h2"
        fontSize="16px"
        fontFamily="inherit"
        className="ehq-cardTitle"
      >
        <Link
          rel="noopener noreferrer"
          target={projectLinkTarget}
          href={`${baseUrl || siteUrl}/${permalink}`}
        >
          {showProjectNameTooltip ? renderWithTooltip() : name}
        </Link>
      </Heading>
    </Item>
  );
};

export default ProjectName;
